import MyTabs from '../../components/MyTabs';
import Section1 from './Section1';

const GeneralDocumentTypes = () => {

    const tabs = [
        { id: "Basic", title: "Basic Document Type Info", Component: Section1 },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralDocumentTypes;